const secondsConverter = seconds => {
  if (seconds === 'other') return 'other'
  const minutesText = Math.floor(seconds / 60)
  const secondsText = Math.round(seconds - minutesText * 60)
  return `${minutesText}:${secondsText < 10 ? `0${secondsText}` : secondsText}`
}

export default secondsConverter
